import { render, staticRenderFns } from "./BusyOverlay.vue?vue&type=template&id=18cfc45e&scoped=true"
import script from "./BusyOverlay.vue?vue&type=script&lang=ts"
export * from "./BusyOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cfc45e",
  null
  
)

export default component.exports